import React, { useEffect, useState, useRef } from "react";
import Headers from "@/components/Headers";
import { Brand } from "@/constants/breadcrumb";
import Search from "./Search";
import Content from "./Content";
import { getList, add, edit } from "@/api/brand";
import { message } from "antd";
import Modal from "./Modal";
import "./index.scss";

const Page = () => {
  const [otherParams, setOtherParams] = useState({});

  const [current, setCurrent] = useState({});

  const [dataSource, setDataSource] = useState([]);

  const [visible, setVisible] = useState(false);

  const containerRef = useRef(null);

  const [page, setPage] = useState({
    pageNum: 1,
    pageSize: 10,
    total: 0,
  });

  const fetchList = () => {
    getList({
      pageNum: page.pageNum,
      pageSize: page.pageSize,
      ...otherParams,
    }).then((res) => {
      if (res.success) {
        setDataSource(res.data.list);
        setPage({ ...page, total: res.data.total });
      }
    });
  };
  useEffect(() => {
    fetchList();
  }, [page.pageSize, page.pageNum, otherParams]);

  const handleTableChange = (pageNum, pageSize) => {
    setPage({ ...page, pageNum, pageSize });
  };

  const handleShowSizeChange = (pageNum, pageSize) => {
    setPage({ ...page, pageNum: 1, pageSize });
  };

  const handleSearch = (values) => {
    setOtherParams({ ...values });
    setPage({ ...page, pageNum: 1 });
  };

  const handleAdd = () => {
    setVisible(true);
  };

  const handleCancel = () => {
    setVisible(false);
    setCurrent({});
  };

  const handleConfirm = (type) => (values) => {
    if (type === "add") {
      add(values).then((res) => {
        if (res.success) {
          setVisible(false);
          message.success("添加品牌商成功!");
          fetchList();
        }
      });
    } else {
      edit(values).then((res) => {
        if (res.success) {
          setVisible(false);
          message.success("编辑品牌商成功!");
          fetchList();
        }
      });
    }
  };

  const handleEdit = (record) => {
    setCurrent(record);
    setVisible(true);
  };

  return (
    <div className="brand-page" ref={containerRef}>
      <Headers BreadCrumbData={Brand}></Headers>

      <Search onSearch={handleSearch} onAdd={handleAdd} />

      <Modal
        visible={visible}
        current={current}
        getContainer={() =>
          containerRef ? containerRef.current : document.body
        }
        onCancel={handleCancel}
        onAdd={handleConfirm("add")}
        onEdit={handleConfirm("edit")}
      />

      <Content
        dataSource={dataSource}
        page={page}
        onTableChange={handleTableChange}
        onShowSizeChange={handleShowSizeChange}
        onEdit={handleEdit}
      />
    </div>
  );
};
export default Page;
